import { render, staticRenderFns } from "./NanudaUserDetail.vue?vue&type=template&id=6fbe1df6&"
import script from "./NanudaUserDetail.vue?vue&type=script&lang=ts&"
export * from "./NanudaUserDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports